import {
  GET_INSTITUTIONAL_MANAGEMENT,
  GET_INSTITUTIONAL_MANAGEMENT_ERROR,
  GET_INSTITUTIONAL_MANAGEMENT_SUCCESS
} from './InstitutionalManagementSection.actions'

const institutionalManagementState = {
  error: undefined,
  loading: true,
  dni: '',
  representativeList: [],
  administratorList: []
}

/**
 * The institutional management section reducer.
 */
const institutionalManagementReducer = (state = institutionalManagementState, { payload, type }) => {
  switch (type) {
    case GET_INSTITUTIONAL_MANAGEMENT: {
      return { ...state, loading: true }
    }
    case GET_INSTITUTIONAL_MANAGEMENT_SUCCESS: {
      return {
        ...state,
        loading: false,
        representativeList: payload.representativeList,
        administratorList: payload.administratorList
      }
    }
    case GET_INSTITUTIONAL_MANAGEMENT_ERROR: {
      return { ...state, loading: false, dni: payload.dni, error: payload.error }
    }
    default: {
      return state
    }
  }
}

export default institutionalManagementReducer
